import type { LeadFormState } from '@core/Atoms/Pdp/FormState.atom';
import type { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';
import { callStartToEvent } from '@tracking/Schemas/CallStart/CallStartToEvent';
import { callSubmitToEvent } from '@tracking/Schemas/CallSubmit/CallSubmitToEvent';
import { ctaClickedToEvent } from '@tracking/Schemas/CtaClicked/CtaClickedToEvent';
import { marketingToEvent } from '@tracking/Schemas/Marketing/MarketingToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';

interface CtaProps {
  searchParams: SearchParamsType;
  userId: string | null | undefined;
  formState: LeadFormState;
  listingId?: string;
  ctaType: string;
  ctaWording: string;
  ctaUrl: string;
}

export function generateFloatingLeasingCtaTracking({
  searchParams,
  userId,
  formState,
  ctaType,
  ctaWording,
  ctaUrl,
}: CtaProps) {
  const marketingDataObj = {
    marketingValues: { ...(searchParams ?? {}) },
  };

  const userData = {
    userId,
    values: { ...formState },
  };
  const ctaEventObj = {
    ctaType,
    ctaWording,
    targetUrl: ctaUrl,
  };

  // event actions
  const ctaEvent = ctaClickedToEvent(ctaEventObj);

  // event entities
  const userEvent = userContextToEvent(userData);
  const marketingEvent = marketingToEvent(marketingDataObj);

  const context = [userEvent, marketingEvent];

  return { event: ctaEvent, context };
}

interface LinkProps {
  searchParams: SearchParamsType;
  userId: string | null | undefined;
  formState: LeadFormState;
  listingId: string;
  leadType: string;
  ctaLocation: string;
  leadId: string;
  callNumber: string;
}

export function generateFloatingLeasingLinkTracking({
  searchParams,
  userId,
  formState,
  listingId,
  leadType,
  ctaLocation,
  leadId,
  callNumber,
}: LinkProps) {
  const marketingDataObj = {
    marketingValues: { ...(searchParams ?? {}) },
  };

  const userData = {
    userId,
    values: { ...formState },
  };

  const leadStartObj = {
    listingId,
    leadType,
    ctaLocation,
  };
  const leadSubmitEventObj = {
    listingId,
    leadId,
    leadType,
    callNumber,
    ctaLocation,
  };

  // event actions
  const callStartEvent = callStartToEvent(leadStartObj);
  const leadSubmitEvent = callSubmitToEvent(leadSubmitEventObj);

  // event entities
  const userEvent = userContextToEvent(userData);
  const marketingEvent = marketingToEvent(marketingDataObj);

  const context = [userEvent, marketingEvent];

  return {
    callStart: { event: callStartEvent, context },
    callSubmit: { event: leadSubmitEvent, context },
  };
}
